import { render, staticRenderFns } from "./NewPasswordForm.vue?vue&type=template&id=4545b3c9&scoped=true&"
import script from "./NewPasswordForm.vue?vue&type=script&lang=js&"
export * from "./NewPasswordForm.vue?vue&type=script&lang=js&"
import style0 from "./NewPasswordForm.vue?vue&type=style&index=0&id=4545b3c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4545b3c9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/var/www/nmg-charitychallenge.com/charity-challenge/frontbuild/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VDialog,VForm,VTextField})
